import { useDeleteProject, useGetProject } from 'api/useProjectsApi';
import { Page } from 'layouts/Admin/Page';
import { useNavigate, useParams } from 'react-router';
import { ProjectForm } from './components/Project/ProjectForm';
import { DeleteEntityById } from 'components/Form/DeleteEntityById';
import { PermissionProtectedComponent } from 'auth/PermissionProtectedComponent';
import { EPermission } from 'api/core';
import { useGetLanguages } from 'api/useTranslationsApi';

export const ProjectSettings = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const { data } = useGetProject(id, true);
  const { data: languages } = useGetLanguages();

  if (!data || !languages) return null;

  const onDeleted = () => {
    navigate('/projects');
  };

  return (
    <Page
      title={data.name}
      breadcrumbs={[
        { name: 'Projekter' },
        { name: data.name },
        { name: 'Indstillinger' },
      ]}
    >
      <PermissionProtectedComponent permissions={[EPermission.ProjectDelete]}>
        <div className="flex mt-2">
          <DeleteEntityById
            id={id}
            trigger={
              <button className="btn btn-error mr-2">
                Slet {data.singleCase ? 'sag' : 'projekt'}
              </button>
            }
            onDeleted={onDeleted}
            titlePropertyKey={'name'}
            getter={useGetProject}
            deleter={useDeleteProject}
          />
        </div>
      </PermissionProtectedComponent>
      <ProjectForm targetProject={data} languages={languages} />
    </Page>
  );
};
